import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";
import {
  visitEntryInterface,
  visitorEntryInterface,
  VisitorInterface,
} from "../../visitor.interface";
import { VISITOR_CONSTANT } from "../constant/visitor.constant";

@Injectable({
  providedIn: "root",
})
export class VisitorService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  public getVisitorData(filters) {
    return this.httpClient.post(VISITOR_CONSTANT.VISITOR_LIST, filters);
  }
  public getVisitsData(filters) {
    return this.httpClient.post(VISITOR_CONSTANT.VISITOR_VISITS_ENTRY, filters);
  }

  public createVisitorData(visitorData: VisitorInterface) {
    return this.httpClient.post(VISITOR_CONSTANT.VISITOR_DATA, visitorData);
  }
  
  public visitorEntryData(visitorEntryData: visitEntryInterface) {
    return this.httpClient.post(
      VISITOR_CONSTANT.VISITOR_ENTRY,
      visitorEntryData
    );
  }

  public searchVisitor(visitorData) {
    return this.httpClient.get(
      `${VISITOR_CONSTANT.VISITOR_SEARCH}/${visitorData}`
    );
  }

  public getVisitorEdit(visitorId: any) {
    return this.httpClient.get(`${VISITOR_CONSTANT.VISITOR_DATA}/${visitorId}`);
  }

  public getVisitData(visitId: any) {
    return this.httpClient.get(`${VISITOR_CONSTANT.VISIT_DATA}/${visitId}`);
  }

  public updateVisitorData(visitorData: VisitorInterface) {
    let visitorId = visitorData.id;
    return this.httpClient.put(
      `${VISITOR_CONSTANT.VISITOR_DATA}/${visitorId}`,
      visitorData
    );
  }

  public updateVisitData(visitData: visitorEntryInterface) {
    let id = visitData.id;
    return this.httpClient.put(
      `${VISITOR_CONSTANT.UPDATE_VISIT_DATA}/${id}`,
      visitData
    );
  }

  public getAllVisitorsEntry() {
    return this.httpClient.get(VISITOR_CONSTANT.VISITOR_VISITS_ENTRY);
  }

  public totalCount() {
    return this.httpClient.get(`${VISITOR_CONSTANT.TOTAL_COUNT}`);
  }
  public visitCount() {
    return this.httpClient.get(`${VISITOR_CONSTANT.VISITS_COUNT}`);
  }
  // public getCast() {
  //   return this.httpClient.get(`${VISITOR_CONSTANT.CAST}`);
  // }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Visitor_Page);
  }

  public getTokenPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Tokengen_Page);
  }

  public createTokenEntry(data: any) {
    return this.httpClient.post(`${VISITOR_CONSTANT.TOKEN_GENERATE}`, data);
  }

  public tokenList(data) {
    return this.httpClient.post(`${VISITOR_CONSTANT.TOKEN_LIST}`, data);
  }

  public getVisitsTotalCount(obj) {
    return this.httpClient.post(`${VISITOR_CONSTANT.VISITS_TOTAL_COUNT}`, obj);
  }

  public updateVisitsAttendStatus(obj) {
    let visitsId = obj.id;
    return this.httpClient.put(
      `${VISITOR_CONSTANT.UPDATE_VISITS}/${visitsId}`,
      obj
    );
  }

  public setActVisitedDate(obj, id) {
    let Id = id;
    return this.httpClient.put(
      `${VISITOR_CONSTANT.UPDATE_ACT_VISIT_DATE}/${Id}`,
      obj
    );
  }

 
  public getVisitCSV(payload) {
    return this.httpClient.post(`${VISITOR_CONSTANT.GET_CSV_VISIT}`, payload, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });
  }
  // public getFilterData(filterData) {
  //   return this.httpClient.post(VISITOR_CONSTANT.VISITOR_DATA, filterData);
  // }
  public getVisitConfig() {
    return this.httpClient.get(PAGE_CONFIG.Visit_page);
  }
  public getCSV(payload) {
    return this.httpClient.post(`/visitor/export/masterdata`, payload, {
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    });
  }
  public getExcelFields() {
    return this.httpClient.get<any[]>(`/visitor/export/masterdata/fields`);
  }

}
